// src/app/state/selectors/fcm.selectors.ts
import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { FcmState } from '../reducers/fcm.reducer';


export const selectFcmState = (state: AppState) => state.fcm;

export const selectCurrentFcmToken = createSelector(
  selectFcmState,
  (state: FcmState) => state.token,
);

export const selectPreviousFcmToken = createSelector(
  selectFcmState,
  (state: FcmState) => state.previousToken,
);